<template>
  <div class="page-container">
    <div class="backbtn-container">
      <router-link to="/my-office">
        <div class="back-btn mr-3">
          <v-icon class="pointer-events-none">mdi-arrow-left</v-icon>
        </div>
      </router-link>
      <span class="p-0">{{ products[0]?.name }}</span>
    </div>
    <div class="table-container">
      <div class="actions_container">
        <vue-select
          ref="ProductSelectRef"
          infinite
          :name="$t('resPerson')"
          :placeholder="$t('resPerson')"
          @item-resolved="setUserList"
          :get-item-promise="
            ({ text, page }) => getUserList({ name: text, page, limit: 15 })
          "
          @input="attachResponse"
          v-model="selectedUser"
          :items="usersList"
          clearable
          itemText="fullName"
          class="user_input no-margin"
          style="width: 300px"
        ></vue-select>

        <div class="generation_box">
          <p>{{ this.$t("generateQrCodeAndInventoryCode") }}</p>
          <v-btn
            v-if="permissions.OFFICE_PRODUCT_ITEM_INV_CODE"
            style="text-transform: capitalize; font-weight: normal"
            color="primary"
            :disabled="isGenerated"
            :loading="generateLoading"
            class="add_product_btn mb-3"
            @click="doGenerate"
          >
            {{ this.$t("generation") }}
          </v-btn>
          <v-btn
            v-if="permissions.OFFICE_PRODUCT_ITEM_QR_CODE"
            style="text-transform: capitalize; font-weight: normal"
            color="primary"
            :disabled="selectedItems.length === 0"
            :loading="loading"
            class="add_product_btn mb-3"
            @click="postQrQode"
          >
            {{ this.$t("downloadFile") }}
          </v-btn>
          <v-checkbox
            v-if="isGenerated && permissions.OFFICE_PRODUCT_ITEM_QR_CODE"
            :value="allSelected"
            ref="mainCheckbox"
            :indeterminate="isIndeterminate"
            @change="toggleAllSelections"
            hide-details
            dense
            class="mt-0 pt-0 ml-4 mb-3"
          ></v-checkbox>
        </div>
      </div>
      <div>
        <table-with-filter
          style="width: 100%"
          :is-filterable="false"
          fixed-header
          :height="$vuetify.breakpoint.height - 160"
          hide-default-footer
          :headers="headers"
          :items="products"
        >
          <template #item.actions="{ item }">
            <v-btn
              v-if="isGenerated && permissions.OFFICE_PRODUCT_ITEM_QR_CODE"
              class="new_style"
              @click="generateQRCode(item)"
            >
              <vue-icon icon="qrcodeIcon"></vue-icon>
            </v-btn>
            <v-checkbox
              v-if="isGenerated && permissions.OFFICE_PRODUCT_ITEM_QR_CODE"
              multiple
              :value="item.id"
              v-model="selectedItems"
              hide-details
              dense
              class="mt-0 pt-0 ml-4"
              @change="updateMainCheckbox"
            ></v-checkbox>
          </template>
        </table-with-filter>
        <VuePagination
          @update:limit="
            (limit) => {
              tableOptions.limit = limit;
              tableOptions.page = 1;
              changePage();
            }
          "
          v-model="tableOptions.page"
          :length="lastPage"
          @input="changePage"
          max-page
          :limit="tableOptions.limit"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TableWithFilter from "../../../../components/ui/table/TableWithFilter.vue";
import VueSelect from "../../../../components/ui/vue-select/VueSelect.vue";
import { makerPagination } from "@/utils/pureFunctions";
import VuePagination from "@/components/ui/vue-pagination/VuePagination.vue";

export default {
  components: { TableWithFilter, VueSelect, VuePagination },
  data() {
    return {
      selectedItems: [],
      resPerson: null,
      userSearchText: null,
      selectedUser: null,
      isGenerated: false,
      loading: false,
      generateLoading: false,
      products: [],
      permissions: {},
      items: [],
      usersList: [],
      tableOptions: {
        page: 1,
        sortBy: "numb",
        sortDirection: false,
        limit: 10,
      },
      lastPage: 0,
    };
  },
  methods: {
    async changePage() {
      await this.$router.replace({
        query: { ...this.tableOptions },
      });
      await this.getProductDataById();
    },
    async generateQRCode(item) {
      try {
        const { data } = await this.$http.get(
          `office-product-item/qr-code/${item.id}`,
          {
            responseType: "blob",
          }
        );

        const imageUrl = window.URL.createObjectURL(data);

        const anchor = document.createElement("a");
        anchor.href = imageUrl;
        anchor.download = `qr-${item.name}.pdf`;
        anchor.click();

        URL.revokeObjectURL(imageUrl);
      } catch (error) {
        console.log(error);
        this.setResponseError({ error: error });
      }
    },
    async postQrQode() {
      try {
        this.loading = true;
        const { data } = await this.$http.post(
          `office-product-item/qr-code/by-limit`,
          [...this.selectedItems],
          {
            responseType: "blob",
          }
        );
        const imageUrl = window.URL.createObjectURL(data);
        const anchor = document.createElement("a");
        anchor.href = imageUrl;
        anchor.download = `qr-codes.pdf`;
        anchor.click();
        URL.revokeObjectURL(imageUrl);
        this.loading = false;
      } catch (e) {
        this.$notify({
          text: e.response.data.error_message.title,
          type: "error",
        });
      }
    },
    setUserList(data) {
      this.usersList = data;
    },
    async doGenerate() {
      this.generateLoading = true;
      try {
        this.showLoading();
        await this.$http.post(
          `office-product-item/generate/${this.$route.params.productIdView}`
        );
        await this.getProductDataById();
      } catch (e) {
        this.$notify({
          text: e.response.data.error_message.title,
          type: "error",
        });
      } finally {
        this.generateLoading = false;
        this.clearLoading();
      }
    },
    async attachResponse() {
      try {
        await this.$http.post(`office-product/attach-responsible`, {
          productId: this.$route.params.productIdView,
          userId: this.selectedUser,
        });
      } catch (e) {
        console.log(e);
      }
    },
    async getUserList(params) {
      try {
        const {
          data: { data },
        } = await this.$http.get(`user/list`, {
          params,
        });
        return {
          data,
        };
      } catch (e) {
        console.log(e);
      }
    },
    async getProductDataById() {
      const id = this.$route.params.productIdView;
      const { page, limit, sortBy, sortDirection } = this.tableOptions;
      const { page: queryPage } = this.$route.query;
      const params = {
        page: page - 1,
        limit,
        sortBy,
        sortDirection,
      };
      if (queryPage && +queryPage !== page) {
        await this.$router.replace({
          query: { page: page.toString() },
        });
      }
      try {
        const { data } = await this.$http.get(`office-product-item/getAll`, {
          params: {
            productId: id,
            placedUserId: this.selectedUser,
            ...params,
          },
        });
        this.products = data.data.items;
        this.permissions = data.permissions;
        this.isGenerated = data.data.generated;

        this.lastPage = makerPagination({
          total: data.data.total,
          limit: this.tableOptions.limit,
        }).lastPage;
      } catch (e) {
        console.log(e);
      }
    },
    updateMainCheckbox() {
      const allSelected = this.products.every((item) =>
        this.selectedItems.includes(item.id)
      );
      this.$refs.mainCheckbox.indeterminate =
        !allSelected && this.selectedItems.length > 0;
    },
    toggleAllSelections() {
      const allProductIds = this.products.map((item) => item.id);
      if (this.selectedItems.length === allProductIds.length) {
        this.selectedItems = [];
      } else {
        this.selectedItems = allProductIds;
      }
      this.updateMainCheckbox();
    },
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("name"),
          value: "name",
        },
        {
          text: this.$t("productCharacteristics"),
          value: "description",
        },
        {
          text: this.$t("codeForInventory"),
          value: "invCode",
        },
        {
          text: this.$t("action"),
          value: "actions",
        },
      ];
    },
    allProductIds() {
      return this.products.map((item) => item.id);
    },
    isIndeterminate() {
      return (
        this.selectedItems.length > 0 &&
        this.selectedItems.length < this.products.length
      );
    },
    allSelected() {
      return this.selectedItems.length === this.products.length;
    },
  },
  async created() {
    await this.getProductDataById();
    const { data } = await this.getUserList({ text: null, page: 0, limit: 15 });
    this.setUserList(data);
  },
};
</script>

<style lang="scss" scoped>
.actions_container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 10px;

  .generation_box {
    display: flex;
    align-items: center;
    gap: 15px;

    p {
      font-family: "Rubik", sans-serif;
      font-size: 12px;
      font-style: italic;
      font-weight: 400;
      line-height: 14.22px;
      color: #a2a5b9;
    }
  }
}

.backbtn-container {
  display: flex;
  align-items: center;
  gap: 3px;
}

.back-btn {
  background-color: #fff;
  border-radius: 6px;
  display: inline-block;
  padding: 4px;
  transition: 0.4s ease;
  border: 1px solid #dfe2e9;
  box-shadow: 0px 1px 2px 0px #0e31581a;

  &:hover {
    border-color: #0096b2;
  }
}

.table-container {
  background-color: #fff;
  border-radius: 6px;
  padding: 24px;
  margin-top: 24px;
}
</style>
